import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Close18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.00006 7.93934L3.53039 2.46967L2.46973 3.53033L7.9394 9L2.46973 14.4697L3.53039 15.5303L9.00006 10.0607L14.4697 15.5303L15.5304 14.4697L10.0607 9L15.5304 3.53033L14.4697 2.46967L9.00006 7.93934Z'
      fill='currentColor'
    />
  </Svg>
);

Close18.displayName = 'Close18';
export default Close18;
